import { Columns } from '#types/grid';

export const columnDefinition: Columns = [
  {
    key: 'facility.facility_lookup_dialog.grid.columns.facility',
    field: 'facility',
    width: 80,
    sort: 'asc',
    sortOrder: 1,
  },
  {
    key: 'facility.facility_lookup_dialog.grid.columns.name',
    field: 'name',
    width: 220,
    sort: 'asc',
    sortOrder: 2,
  },
  {
    key: 'facility.facility_lookup_dialog.grid.columns.phone',
    field: 'phone',
    width: 100,
  },
  {
    key: 'facility.facility_lookup_dialog.grid.columns.state',
    field: 'state',
    width: 60,
  },
  {
    key: 'facility.facility_lookup_dialog.grid.columns.campusabbrev',
    field: 'campusabbrev',
    width: 100,
  },
  {
    key: 'facility.facility_lookup_dialog.grid.columns.manager',
    field: 'manager',
    width: 140,
  },
  {
    key: 'facility.facility_lookup_dialog.grid.columns.facilitystatusabbrev',
    field: 'facilitystatusabbrev',
    width: 80,
  },

  // end of default columns

  {
    key: 'facility.facility_lookup_dialog.grid.columns.campus',
    field: 'campus',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'facility.facility_lookup_dialog.grid.columns.facilitystatus',
    field: 'facilitystatus',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },
];
